export const ROUTE_NAMES = {
  ACCESS_DENIED: 'access_denied',
  ACTIVATE: 'activate',
  BLOCKED: 'blocked',
  CALLBACK: 'callback',
  CALLOFF: 'callOff',
  DASHBOARD: 'dashboard',
  ERROR: 'error',
  EXPIRED: 'expired',
  FORBIDDEN: 'forbidden',
  LOGOUT: 'logout',
  MAINTENANCE: 'maintenance',
  MOTION_VIEW: 'motionView',
  NOT_FOUND: 'notFound',
  REGISTER: 'register',
  SERVICE_UNAVAILABLE: 'serviceUnavailable',
  UNAUTHORIZED: 'unauthorized',
  USER_MANAGEMENT: 'userManagement',
} as const

export type RouteName = (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES]
